import { useCallback, useState } from "react";
import { RelatorioAuditoriaQueryParams } from "core/features/relatorios/typings/index";
import moment from "moment";

export const defaultFiltroRelatorioAuditoria: RelatorioAuditoriaQueryParams = {
  dataInicio: moment().startOf("month").format("YYYY-MM-DD"),
  dataFim: moment().endOf("month").format("YYYY-MM-DD"),
  page: 1,
  limit: 10,
  search: undefined,
  tenantsIds: [],
  tipoEvento: undefined,
  usuarioId: undefined,
};

function useFiltroRelatorioAuditoria() {
  const [filtro, setFiltro] = useState<RelatorioAuditoriaQueryParams>(
    defaultFiltroRelatorioAuditoria
  );

  const onChangeFiltro = useCallback(
    (_filtro: Partial<RelatorioAuditoriaQueryParams>) => {
      setFiltro((state) => ({ ...state, ..._filtro }));
    },
    []
  );

  const onResetFiltro = useCallback(() => {
    setFiltro(defaultFiltroRelatorioAuditoria);
  }, []);

  return {
    filtro,
    setFiltro,
    onChangeFiltro,
    onResetFiltro,
  };
}

export default useFiltroRelatorioAuditoria;
